import { Button, ButtonVariant, Component, ComponentFactory, Label, LabelProps, Panel } from "@mcleod/components";
import { PermissionsDesignerTab } from "./PermissionsDesignerTab";
import { Alignment, StringUtil } from "@mcleod/core";

export class PermissionsTabTooltip extends Panel {
    private designerTab: PermissionsDesignerTab;

    constructor(designerTab: PermissionsDesignerTab) {
        super();
        this.designerTab = designerTab;
        this.generateTooltipContent();
    }

    private generateTooltipContent() {
        let nestedLayoutLabelAdded = false;

        this.designerTab.permedComponentMap?.forEach((components, path) => {
            const bulletPointLabelProps = this.getBulletListLabelProps(path, components);

            if (bulletPointLabelProps.length > 0) {
                if (path === this.designerTab.path) {
                    this.addDirectPermissionsContent(bulletPointLabelProps);
                } else {
                    if (!nestedLayoutLabelAdded) {
                        nestedLayoutLabelAdded = true;
                        this.addNestedLayoutsLabel();
                    }

                    this.addNestedLayoutPanel(path, bulletPointLabelProps);
                }
            }
        });
    }

    private addDirectPermissionsContent(bulletPointLabelProps: Partial<LabelProps>[]) {
        this.add(new Label({
            text: "Permissions set directly in this layout",
            paddingTop: 8,
            fontBold: true
        }));
        this.add(...ComponentFactory.createBulletedList(bulletPointLabelProps));
    }

    private addNestedLayoutsLabel() {
        this.add(new Label({
            text: "Permissions set in nested layouts",
            paddingTop: 12,
            fontBold: true
        }));
    }

    private addNestedLayoutPanel(path: string, bulletPointLabelProps: Partial<LabelProps>[]) {
        const nestedLayoutPanel = new Panel({ padding: 0, paddingRight: 16 });

        nestedLayoutPanel.add(new Label({
            text: `${StringUtil.stringAfterLast(path, "/")} Layout`,
            paddingTop: 8,
            paddingLeft: 16,
            rowBreak: false,
        }));

        const button = new Button({
            id: "buttonDetail",
            margin: 0,
            imageName: "detail",
            tooltip: "Open for editing field-level permissions",
            variant: ButtonVariant.round,
            onClick: () => this.designerTab.designer.openTab({ path })
        });
        nestedLayoutPanel.add(button);

        nestedLayoutPanel.add(...ComponentFactory.createBulletedList(bulletPointLabelProps));

        this.add(nestedLayoutPanel);
    }

    private getBulletListLabelProps(path: string, permedComps: Set<Component>): Partial<LabelProps>[] {
        if (!permedComps) return [];

        return Array.from(permedComps).map(component => ({
            text: component.id,
            tooltip: "Scroll to component",
            tooltipPosition: Alignment.RIGHT,
            color: "primary",
            paddingLeft: 16,
            onClick: () => {
                this.designerTab.selectAndScrollToComponent(path, component);
            }
        }));
    }
}
